<template>
  <div class="">
    <div class="filter-bar ch-flex" id="ch-filter-bar">
      <div class="ch-flex__item">
        <div class="item f" @click="popup = true">
          <div class="value"><md-icon name="arrow-down"></md-icon></div>
          <label>筛选</label>
        </div>
      </div>
      <div class="ch-flex__item">
        <div class="item" @click="isPickerShow0 = true">
          <div class="value">
            <span>{{currentSort}}</span>
            <md-icon name="arrow-down"></md-icon>
          </div>
          <label>排序</label>
        </div>
      </div>
    </div><!-- E filter bar -->


    <md-picker
            v-model="isPickerShow0"
            :data="sortType"
            large-radius
            @confirm="onPickerConfirm"
            title="选择排序方式"
    ></md-picker>

    <md-popup
            v-model="popup"
            position="left"
    >
      <div class="md-example-popup md-example-popup-left">
        <div class="activities-search form-tg">
          <div class="activities-search-input activities-search-input--age">
            <select v-model="filter.age" class="form-control">
              <option value="">全部年龄段</option>
              <option :value="t.value" v-for="t in ages" :key="t.value">{{t.label}}</option>
            </select>
          </div>
          <div class="activities-search-input activities-search-input--age">
            <select v-model="filter.weekday" class="form-control">
              <option value="">全部日期</option>
              <option :value="index" v-for="(value,index) in days" :key="index">{{value}}</option>
            </select>
          </div>
          <div class="activities-search-input activities-search-input--age">
            <select v-model="filter.season" class="form-control">
              <option value="">全部季节</option>
              <option :value="t.value" v-for="t in seasons" :key="t.value">{{t.label}}</option>
            </select>
          </div>
          <div class="activities-search-input activities-search-input--age">
            <select v-model="filter.tag" class="form-control">
              <option value="">全部标签</option>
              <optgroup :label="tag.label" v-for="tag in tags" :key="tag.type">
                <option :value="t.id" v-for="t in tag.tags" :key="t.id">{{t.name}}</option>
              </optgroup>
            </select>
          </div>
          <div class="activities-search-input activities-search-input--age">
            <select v-model="filter.leader_id" class="form-control">
              <option value="">全部Leader</option>
              <option :value="t.id" v-for="t in leaders" :key="t.id">{{t.name}}</option>
            </select>
          </div>
          <div class="activities-search-input activities-search-input--age">
            <select v-model="filter.distance" class="form-control">
              <option value="">不限距离</option>
              <option :value="t.value" v-for="t in distances" :key="t.value">{{t.label}}</option>
            </select>
          </div>
          <div class="activities-search-input activities-search-input--submit">
            <input type="button" name="commit" value="搜索" @click="search" class="btn-tg btn-tg-orange btn-tg-full">
          </div>
        </div>
      </div>
    </md-popup>
  </div>
</template>

<script>
import {Icon,Picker,Popup} from "mand-mobile";
export default {
  name: "CourseFilter",
  components: {
      [Icon.name]: Icon,
      [Picker.name]: Picker,
      [Popup.name]: Popup,
  },
  props: [],
    data() {
      return {
          popup: false,
          isPickerShow0: false,
          currentSort: "最近",
          sort:'nearby',
          sortType: [[
              {
                  text: '最新',
                  value: 'latest',
              },
              {
                  text: '最近',
                  value: 'nearby',
              },
          ]],
          seasons:[],
          tags:[],
          ages:[],
          distances:[],
          leaders:[],
          days:["每周日","每周一","每周二","每周三","每周四","每周五","每周六"],
          filter:{season:'',tag:'',age:'',distance:'',leader_id:'',weekday:''},
      }
    },
  methods: {
      onPickerConfirm(picked) {
          console.log(picked);
          this.currentSort = picked[0].text;
          this.sort = picked[0].value;
          this.$emit("onSearch", {...this.filter, sort:picked[0].value});
      },
      search() {
          this.$emit("onSearch", {...this.filter, sort:this.sort});
          this.popup = false;
      },
  },
    created() {
        this.$http.get('courses-filters')
            .then(({data}) => {
                console.log(data);
                this.seasons = data.seasons;
                this.tags = data.tags;
                this.ages = data.ages;
                this.distances = data.distances;
                this.leaders = data.leaders;
            });
    }
};
</script>

<style lang="scss" scoped>
  .filter-bar {
    border-top: 1px solid #afafaf;
    border-bottom: 1px solid #afafaf;
    justify-content: normal;
    align-items: normal;
    height: 100px;

    .item {
      padding:  0 20px;
      line-height: 100px;
      label {
        color: #414241;
        font-size: 32px;
        font-weight: 500;
      }
      &.f {
        border-right: 1px solid #afafaf;
      }

      .value {
        float: right;
        width: 150px;
        text-align: right;
        span {
          font-size: 24px;
          margin-right: 10px;
        }

        .md-icon {
          color: #f26522;
          font-weight:bold;
        }
      }
    }
  }
  .activities-search-input {
    margin-bottom:20px;
  }
</style>
<style lang="stylus" scoped="">
  /*.md-example-child-popup-0*/
    /*float left*/
    /*width 100%*/
    /*.md-button*/
      /*margin-bottom 20px*/
    .md-example-popup
      box-sizing border-box
      background-color #f3eee4
    .md-example-popup-left, .md-example-popup-right
      min-height 100%
      padding 30px
      width 600px
</style>